"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoAutoplay = /** @class */ (function () {
    function VideoAutoplay(selector) {
        var _this = this;
        this.selector = selector;
        // Check the scroll position to add autoplay to videos
        this.checkScrollPosition = function () {
            var viewPortTop = window.scrollY;
            var viewPortBottom = window.scrollY + window.innerHeight / 2;
            _this.videos.forEach(function (video) {
                video.muted = true;
                var top = video.getBoundingClientRect();
                var videoStart = 265;
                if (top.y < videoStart && top.y > -videoStart && video.autoplay == true) {
                    video.play();
                }
                else if (top.y < -videoStart || top.y > videoStart) {
                    video.pause();
                }
            });
        };
        this.videos = document.querySelectorAll(this.selector);
        window.addEventListener('scroll', this.checkScrollPosition);
    }
    return VideoAutoplay;
}());
exports.default = VideoAutoplay;
